import { observable, mix } from "@chorda/core";
export const DropdownItem = (props) => {
    return mix(props === null || props === void 0 ? void 0 : props.as, {
        css: 'dropdown-item',
        tag: 'a',
        reactions: {
            text: (v) => ({ text: v }),
            isSelected: (v) => ({ classes: { 'is-active': v } }),
            isCurrent: (v) => ({ classes: { 'is-current': v } }),
        }
    }, {
        defaults: {
            //            offsetTop: () => observable(null),
            text: () => observable(null),
            //            currentOffsetTop: () => observable(null),
        },
        injections: {
            item: props.item$,
            text: props.text$,
            isSelected: props.isSelected$,
            //            offsetTop: props.offsetTop$,
            isCurrent: props.isCurrent$,
            // currentOffsetTop: props.currentOffset$,
            // currentHeight: props.currentHeight$,            
        },
        events: {
            $dom: {
                click: props.onClick
            }
        },
        joints: {
            init: ({ $dom }) => {
                // watch(() => {
                //     const el = $dom.$value
                //     const active = isActive.$value
                //     if (el && active) {
                //         console.log('offset', el.offsetTop)
                //         offsetTop.$value = el.offsetTop
                //     }
                // }, [$dom, isActive])
                // watch(() => {
                //     const el = $dom.$value
                //     const current = isCurrent.$value
                //     if (el && current) {
                //         currentOffsetTop.$value = el.offsetTop
                //         currentHeight.$value = el.getBoundingClientRect().height
                //     }
                // }, [$dom, isCurrent])
            },
            //             itemPosition: ({$dom, offset, active}) => {
            //                 $dom.$subscribe(el => {
            //                     if (el && active.$value) {
            //                         offset.$value = el.offsetTop
            // //                            console.log('offset', el.offsetTop)
            //                     }
            //                 })
            //             },
            //             currentItemPosition: ({current, $dom, currentOffset, currentHeight}) => {
            //                 current.$subscribe(next => {
            //                     const el = $dom.$value
            //                     if (el && next) {
            // //                            console.log('---- current offset', $dom.$value.offsetTop, currentOffset.$value)
            //                         currentOffset.$value = el.offsetTop
            //                         currentHeight.$value = el.getBoundingClientRect().height
            // //                            console.log(currentOffset)
            //                     }
            //                 })
            //             }
        }
    });
};
